export class OnboardingCredential {
    agencyId: string;
    email: string;
    password: string;
}
export class loginBO {
    userName: string;
    password: string;
    agencyCode: string;
    roleId: string | null;
    type: string;
}
